export const focusFirstField = (formId) => {
    const formElement = document.querySelectorAll(`#form-${formId}`)?.[0];
    const input = formElement?.querySelector('input');
    if (input) {
        input.focus({ preventScroll: true });
    }
};
//# sourceMappingURL=focus-first-field.js.map